import { render } from "./ModalBlock.vue?vue&type=template&id=883c899a"
import script from "./ModalBlock.vue?vue&type=script&lang=js"
export * from "./ModalBlock.vue?vue&type=script&lang=js"

import "./ModalBlock.vue?vue&type=style&index=0&id=883c899a&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__